import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import { ReportsKpiMetric } from '@dataTypes/reports.type'

export const CLAIMS_PERFORMANCE_FILTERS = REPORTS_DEFAULT_FILTERS

export const CLAIMS_PERFORMANCE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'count' | 'percent'
}> = [
  {
    id: 'total-claims-submitted',
    title: 'Total Claims Submitted',
    footer: 'Count of all submitted claims',
    format: 'count',
  },
  {
    id: 'claims-pending',
    title: 'Claims Pending',
    footer: 'Pending claims in selected period',
    format: 'count',
  },
  {
    id: 'claims-overdue',
    title: 'Claims Overdue',
    footer: 'Overdue claims in selected period',
    format: 'count',
  },
  {
    id: 'claims-denied',
    title: 'Claims Denied / Rejected',
    footer: 'Denied claims in selected period',
    format: 'count',
  },
  {
    id: 'claims-acceptance-rate',
    title: 'Claim Acceptance Rate %',
    footer: 'Accepted divided by submitted claims',
    format: 'percent',
  },
  {
    id: 'resubmission-rate',
    title: 'Resubmission Rate %',
    footer: 'Resubmitted divided by sub. claims',
    format: 'percent',
  },
]

/** @deprecated Use CLAIMS_PERFORMANCE_KPI_DEFINITIONS with live API values */
export const CLAIMS_PERFORMANCE_KPI_METRICS: ReportsKpiMetric[] =
  CLAIMS_PERFORMANCE_KPI_DEFINITIONS.map((def) => ({
    id: def.id,
    title: def.title,
    footer: def.footer,
    value: '—',
  }))

export type PaymentTrendRow = {
  month: string
  /** Average days to payment for the month. */
  days: number
}

/** @deprecated Prefer live average-days-to-payment-by-period API data */
export const AVG_DAYS_TO_PAYMENT_TREND: PaymentTrendRow[] = [
  { month: 'Dec', days: 16.9 },
  { month: 'Jan', days: 18.7 },
  { month: 'Feb', days: 19.2 },
  { month: 'Mar', days: 19.3 },
]

export type ClaimsStatusRow = {
  label: string
  count: number
}

/**
 * @deprecated Prefer live claims-status-overview API data
 * NOTE: Bar values for Pending/Overdue/Denied were inflated for chart
 * readability only in the mock.
 */
export const CLAIMS_STATUS_OVERVIEW: ClaimsStatusRow[] = [
  { label: 'Submitted', count: 7809 },
  { label: 'Pending', count: 3900 },
  { label: 'Overdue', count: 2100 },
  { label: 'Denied', count: 1200 },
]

export type CarrierDaysRow = {
  carrier: string
  days: number
}

/** @deprecated Prefer live average-days-to-payment-by-carrier API data */
export const AVG_DAYS_BY_CARRIER: CarrierDaysRow[] = [
  { carrier: 'Delta Dental', days: 23.1 },
  { carrier: 'Aetna', days: 22.8 },
  { carrier: 'MetLife', days: 19.3 },
  { carrier: 'Cigna', days: 16.3 },
  { carrier: 'Guardian', days: 24.3 },
]

export type AgingBucketRow = {
  label: string
  amount: number
}

/** @deprecated Prefer live insurance-ar-aging-buckets API data */
export const INSURANCE_AGING_BREAKDOWN: AgingBucketRow[] = [
  { label: '0-30', amount: 140000 },
  { label: '31-60', amount: 82000 },
  { label: '61-90', amount: 54000 },
  { label: '90+', amount: 46000 },
]
